import type { DeepPartial } from '@luna/utils-ts';

import type { OwnFxTransfer } from './OwnFxTransfer';

export const SK: DeepPartial<OwnFxTransfer> = {};
